import React from 'react'
import CircleImage from '../../../../assets/products/circle.webp'

const Circle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="694"
      height="420"
      viewBox="-150 0 740 50"
      fill="none"
    >
      <image x="-430" y="-300" width="1080" height="760" xlinkHref={CircleImage} />
      <g id="Group 1500">
        <g id="B-Comp">
          <g filter="url(#filter0_d_5443_8524)">
            <rect
              id="B-Background"
              x="132"
              y="247"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-90 132 247)"
              fill="transparent"
            />
            <path
              id="B-Text"
              d="M152.904 227.384H149.617L149.6 225.574H152.359C152.846 225.574 153.244 225.512 153.555 225.389C153.865 225.26 154.097 225.076 154.249 224.836C154.407 224.589 154.486 224.291 154.486 223.939C154.486 223.541 154.41 223.218 154.258 222.972C154.111 222.726 153.88 222.547 153.563 222.436C153.253 222.325 152.852 222.269 152.359 222.269H150.531V233.001H147.895V220.204H152.359C153.104 220.204 153.769 220.274 154.354 220.415C154.946 220.555 155.447 220.769 155.857 221.056C156.268 221.343 156.581 221.707 156.798 222.146C157.015 222.58 157.123 223.095 157.123 223.693C157.123 224.22 157.003 224.707 156.763 225.152C156.528 225.597 156.156 225.961 155.646 226.242C155.143 226.523 154.483 226.678 153.669 226.708L152.904 227.384ZM152.79 233.001H148.896L149.925 230.944H152.79C153.253 230.944 153.631 230.871 153.924 230.724C154.217 230.572 154.434 230.367 154.574 230.109C154.715 229.851 154.785 229.555 154.785 229.221C154.785 228.846 154.721 228.521 154.592 228.246C154.469 227.97 154.27 227.759 153.994 227.613C153.719 227.461 153.355 227.384 152.904 227.384H150.364L150.382 225.574H153.546L154.152 226.286C154.932 226.274 155.559 226.412 156.033 226.699C156.514 226.98 156.862 227.346 157.079 227.797C157.302 228.249 157.413 228.732 157.413 229.248C157.413 230.068 157.234 230.759 156.877 231.322C156.52 231.879 155.995 232.297 155.304 232.579C154.618 232.86 153.78 233.001 152.79 233.001Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M0.646447 189.646C0.451184 189.842 0.451184 190.158 0.646447 190.354L3.82843 193.536C4.02369 193.731 4.34027 193.731 4.53553 193.536C4.7308 193.34 4.7308 193.024 4.53553 192.828L1.70711 190L4.53553 187.172C4.7308 186.976 4.7308 186.66 4.53553 186.464C4.34027 186.269 4.02369 186.269 3.82843 186.464L0.646447 189.646ZM304.354 190.354C304.549 190.158 304.549 189.842 304.354 189.646L301.172 186.464C300.976 186.269 300.66 186.269 300.464 186.464C300.269 186.66 300.269 186.976 300.464 187.172L303.293 190L300.464 192.828C300.269 193.024 300.269 193.34 300.464 193.536C300.66 193.731 300.976 193.731 301.172 193.536L304.354 190.354ZM1 190.5L3.525 190.5L3.525 189.5L1 189.5L1 190.5ZM8.575 190.5L13.625 190.5L13.625 189.5L8.575 189.5L8.575 190.5ZM18.675 190.5L23.725 190.5L23.725 189.5L18.675 189.5L18.675 190.5ZM28.775 190.5L33.825 190.5L33.825 189.5L28.775 189.5L28.775 190.5ZM38.875 190.5L43.925 190.5L43.925 189.5L38.875 189.5L38.875 190.5ZM48.975 190.5L54.025 190.5L54.025 189.5L48.975 189.5L48.975 190.5ZM59.075 190.5L64.125 190.5L64.125 189.5L59.075 189.5L59.075 190.5ZM69.175 190.5L74.225 190.5L74.225 189.5L69.175 189.5L69.175 190.5ZM79.275 190.5L84.325 190.5L84.325 189.5L79.275 189.5L79.275 190.5ZM89.375 190.5L94.425 190.5L94.425 189.5L89.375 189.5L89.375 190.5ZM99.475 190.5L104.525 190.5L104.525 189.5L99.475 189.5L99.475 190.5ZM109.575 190.5L114.625 190.5L114.625 189.5L109.575 189.5L109.575 190.5ZM119.675 190.5L124.725 190.5L124.725 189.5L119.675 189.5L119.675 190.5ZM129.775 190.5L134.825 190.5L134.825 189.5L129.775 189.5L129.775 190.5ZM139.875 190.5L144.925 190.5L144.925 189.5L139.875 189.5L139.875 190.5ZM149.975 190.5L155.025 190.5L155.025 189.5L149.975 189.5L149.975 190.5ZM160.075 190.5L165.125 190.5L165.125 189.5L160.075 189.5L160.075 190.5ZM170.175 190.5L175.225 190.5L175.225 189.5L170.175 189.5L170.175 190.5ZM180.275 190.5L185.325 190.5L185.325 189.5L180.275 189.5L180.275 190.5ZM190.375 190.5L195.425 190.5L195.425 189.5L190.375 189.5L190.375 190.5ZM200.475 190.5L205.525 190.5L205.525 189.5L200.475 189.5L200.475 190.5ZM210.575 190.5L215.625 190.5L215.625 189.5L210.575 189.5L210.575 190.5ZM220.675 190.5L225.725 190.5L225.725 189.5L220.675 189.5L220.675 190.5ZM230.775 190.5L235.825 190.5L235.825 189.5L230.775 189.5L230.775 190.5ZM240.875 190.5L245.925 190.5L245.925 189.5L240.875 189.5L240.875 190.5ZM250.975 190.5L256.025 190.5L256.025 189.5L250.975 189.5L250.975 190.5ZM261.075 190.5L266.125 190.5L266.125 189.5L261.075 189.5L261.075 190.5ZM271.175 190.5L276.225 190.5L276.225 189.5L271.175 189.5L271.175 190.5ZM281.275 190.5L286.325 190.5L286.325 189.5L281.275 189.5L281.275 190.5ZM291.375 190.5L296.425 190.5L296.425 189.5L291.375 189.5L291.375 190.5ZM301.475 190.5L304 190.5L304 189.5L301.475 189.5L301.475 190.5Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter1_d_5443_8524)">
            <rect
              id="A-Background"
              x="400"
              y="61.5"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(180 400 61.5)"
              fill="transparent"
            />
            <path
              id="A-Text"
              d="M379.798 36.8906L376.317 47.499L373.514 47.499L378.269 34.7021H380.053L379.798 36.8906ZM382.689 47.499L379.2 36.8906L378.919 34.7021H380.721L385.502 47.499L382.689 47.499ZM382.531 42.7354V44.8008L375.772 44.8008V42.7354L382.531 42.7354Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M342.646 71.3536C342.842 71.5488 343.158 71.5488 343.354 71.3536L346.536 68.1716C346.731 67.9763 346.731 67.6597 346.536 67.4645C346.34 67.2692 346.024 67.2692 345.828 67.4645L343 70.2929L340.172 67.4645C339.976 67.2692 339.66 67.2692 339.464 67.4645C339.269 67.6597 339.269 67.9763 339.464 68.1716L342.646 71.3536ZM343.354 10.6464C343.158 10.4512 342.842 10.4512 342.646 10.6464L339.464 13.8284C339.269 14.0237 339.269 14.3403 339.464 14.5355C339.66 14.7308 339.976 14.7308 340.172 14.5355L343 11.7071L345.828 14.5355C346.024 14.7308 346.34 14.7308 346.536 14.5355C346.731 14.3403 346.731 14.0237 346.536 13.8284L343.354 10.6464ZM343.5 71L343.5 68.5L342.5 68.5L342.5 71L343.5 71ZM343.5 63.5L343.5 58.5L342.5 58.5L342.5 63.5L343.5 63.5ZM343.5 53.5L343.5 48.5L342.5 48.5L342.5 53.5L343.5 53.5ZM343.5 43.5L343.5 38.5L342.5 38.5L342.5 43.5L343.5 43.5ZM343.5 33.5L343.5 28.5L342.5 28.5L342.5 33.5L343.5 33.5ZM343.5 23.5L343.5 18.5L342.5 18.5L342.5 23.5L343.5 23.5ZM343.5 13.5L343.5 11L342.5 11L342.5 13.5L343.5 13.5Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5443_8524"
          x="102"
          y="186"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5443_8524" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5443_8524"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5443_8524"
          x="329"
          y="0.5"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5443_8524" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5443_8524"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Circle
